<div
  [pTooltip]="getTooltipText() ? (getTooltipText() | transloco) : ''"
  [tooltipDisabled]="!getTooltipText()"
  tooltipPosition="top"
  [ngClass]="{
    'cursor-not-allowed': !isAccessible() && isStepDisabled(),
  }"
  *transloco="let t; prefix: 'project'"
>
  <app-generic-button-card
    [title]="chapterNumberTitle"
    [cardLevel]="CardLevel.Second"
    [buttonSeverity]="getChapterButtonSeverity()"
    class="bg-second-level"
    [testId]="'chapter-card-' + chapter().configId"
    [actionLabel]="t('detail.goToPage')"
    [actionDisabled]="isStepDisabled()"
    [actionIcon]="'pi pi-arrow-right'"
    [actionIconPos]="'right'"
    [onAction]="onGoToChapter.bind(this)"
  >
    <div card-body>
      @if (accessControlService.isChapterInDevelopment(chapter().configId)) {
        <div class="text-center py-4">
          <div class="text-sm text-gray-400">
            {{ 'project.steps.underDevelopment' | transloco }}
          </div>
        </div>
      } @else {
        <app-progress-bar
          [completed]="completedSteps"
          [total]="totalSteps"
          [label]="t('stepsCompleted')"
          testIdInfo="chapter-progress-info"
          testIdBar="chapter-progress-bar"
        ></app-progress-bar>
      }
    </div>
  </app-generic-button-card>
</div>
